// Tile counts per FEATURE_SECTIONS entry, in page order. Kept as a literal so the router's
// Suspense fallback does not have to import the icon-heavy feature-card config just to size its
// skeleton. hub-skeleton-sections.test.ts keeps this in sync with the derived value.
export const HUB_SKELETON_SECTIONS = [3, 4] as const
